var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('button',{staticClass:"ml-2 btn btn-default",attrs:{"id":_vm.row.id},on:{"click":_vm.impersonate}},[_vm._v("\n    Login "),_c('i',{staticClass:"fa fa-sign-in"})])])}
var staticRenderFns = []

export { render, staticRenderFns }